import React from 'react';
import PublicCmsPage from 'components/PublicCmsPage';

const AccountDeletion = () => {
    return <PublicCmsPage />;
};

export default AccountDeletion;
